"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountFormatSelector = createAmountFormatSelector;
/* eslint-disable functional/no-this-expression */
/*
 UI to select a unit and a number of decimals independently of each other
 */
const react_1 = __importDefault(require("react"));
const uom_1 = require("uom");
const amount_format_wrapper_1 = require("./amount-format-wrapper");
const defaultClearButton = (props) => react_1.default.createElement("button", Object.assign({}, props));
const defaultCancelButton = (props) => react_1.default.createElement("button", Object.assign({}, props));
const defaultPrecisionSelector = (props) => react_1.default.createElement("select", Object.assign({}, props));
const defaultUnitSelector = (props) => react_1.default.createElement("select", Object.assign({}, props));
const defaultFormatWrapper = amount_format_wrapper_1.AmountFormatWrapper;
function createAmountFormatSelector({ ClearButton = defaultClearButton, CancelButton = defaultCancelButton, PrecisionSelector = defaultPrecisionSelector, UnitSelector = defaultUnitSelector, AmountFormatWrapper = defaultFormatWrapper }) {
    // eslint-disable-next-line functional/no-class
    return class AmountFormatSelector extends react_1.default.Component {
        constructor(props) {
            super(props);
            this.state = { active: false };
        }
        componentDidUpdate(_, prevState) {
            if (this.props.onFormatSelectorActiveChanged &&
                prevState.active !== this.state.active) {
                this.props.onFormatSelectorActiveChanged(this.state.active);
            }
        }
        render() {
            const { selectedUnit, selectedDecimalCount, onFormatChanged, onFormatCleared, unitsFormat, units } = this.props;
            // If there is no handler for onFormatChanged then the user should not be able to change the format
            if (!this.state.active || !onFormatChanged) {
                const format = uom_1.UnitFormat.getUnitFormat(selectedUnit, unitsFormat);
                return (react_1.default.createElement(AmountFormatWrapper, { active: this.state.active, onClick: () => this.setState({ active: true }) }, format ? format.label : ""));
            }
            // Get a list of all units within the quantity
            const quantityUnits = uom_1.UnitMap.getUnitsForQuantity(selectedUnit.quantity, units);
            const unitNames = quantityUnits.map(u => uom_1.Serialize.unitToString(u));
            const selectedUnitName = uom_1.Serialize.unitToString(selectedUnit);
            const decimalCounts = [0, 1, 2, 3, 4, 5];
            if (decimalCounts.indexOf(selectedDecimalCount) === -1) {
                decimalCounts.push(selectedDecimalCount);
            }
            return (react_1.default.createElement(AmountFormatWrapper, { active: this.state.active },
                react_1.default.createElement(UnitSelector, { value: selectedUnitName, 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange: (e) => {
                        this.setState({ active: false });
                        _onUnitChange(e, quantityUnits, selectedDecimalCount, onFormatChanged);
                    } }, quantityUnits.map((u, index) => {
                    const format = uom_1.UnitFormat.getUnitFormat(u, unitsFormat);
                    return (react_1.default.createElement("option", { key: unitNames[index], value: unitNames[index] },
                        " ",
                        format ? format.label : "",
                        " "));
                })),
                react_1.default.createElement(PrecisionSelector, { value: selectedDecimalCount.toString(), 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange: (e) => {
                        this.setState({ active: false });
                        _onDecimalCountChange(e, selectedUnit, onFormatChanged);
                    } }, decimalCounts.map(dc => (react_1.default.createElement("option", { key: dc.toString(), value: dc.toString() }, dc)))),
                onFormatCleared && (react_1.default.createElement(ClearButton, { onClick: () => {
                        this.setState({ active: false });
                        onFormatCleared();
                    } }, "\u00A0")),
                react_1.default.createElement(CancelButton, { onClick: () => this.setState({ active: false }) }, "\u00A0")));
        }
    };
}
function _onDecimalCountChange(e, selectedUnit, onFormatChanged) {
    const selectedIndex = e.currentTarget.selectedIndex;
    const selectedDecimalCount = selectedIndex;
    onFormatChanged(selectedUnit, selectedDecimalCount);
}
function _onUnitChange(e, units, selectedDecimalCount, onFormatChanged) {
    const selectedIndex = e.currentTarget.selectedIndex;
    const selectedUnit = units[selectedIndex];
    onFormatChanged(selectedUnit, selectedDecimalCount);
}
//# sourceMappingURL=amount-format-selector.js.map